export const fetchPaginatedData = (data, rootKey) => {
  return data.pages?.flatMap((page) => page[rootKey].map((item) => item));
};
